import CreateJob from './CreateJob';
import { useJobs } from '../hooks/useJobs';
import { useState } from 'react';
import { Job } from '../types';

export default function CreateJobPage() {
  const { addJob } = useJobs();
  const [submitting, setSubmitting] = useState(false);

  // Show a simple modal or notification for success/failure (replace as needed)
  const handleSubmit = async (jobData: Omit<Job, 'id'>) => {
    console.log('Submitting job...', jobData);
    setSubmitting(true);
    try {
      await addJob(jobData);
      console.log('Job submission successful');
      alert('Job created successfully!');
      // Optionally: reset form, close modal, or redirect
    } catch (err) {
      console.error('Job creation error in handleSubmit:', err);
      alert('Failed to create job. Please try again.');
      console.error('Job creation error:', err);
    } finally {
      console.log('Finished submission attempt.');
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    // Optionally: close modal or navigate away
    alert('Job creation cancelled');
  };

  return (
    <>
      <CreateJob onSubmit={handleSubmit} onCancel={handleCancel} />
      {submitting && <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50"><div className="bg-white p-6 rounded shadow">Submitting...</div></div>}
    </>
  );
}